import { Component, OnInit } from '@angular/core';
import { TemporalidadeServiceService } from './temporalidade-service.service';
import { TemporalidadeModel } from './temporalidade.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DadosArquivisticosService } from 'app/components/dados-arquivisticos/dados-arquivisticos.service';
import {MatTableDataSource} from '@angular/material';
import { GlobalHelpDialogComponent } from 'app/components/dialog/global-help-dialog/global-help-dialog.component';

@Component({
  selector: 'app-temporalidade',
  templateUrl: './temporalidade.component.html',
  styleUrls: ['./temporalidade.component.scss']
})
export class TemporalidadeComponent implements OnInit {

  public temporalidade: TemporalidadeModel[];
  public nodeId: Number;
  public temporalidadeForm: FormGroup;
  public loading = true;
  public tipoName: String;
  public valorCorrente;
  public valorIntermediario;
  public eliminar = false;
  public permanente = false;
  public isToSave = false;
  public isToEdit = false;
  public displayedColumns = ['prazoAcervoCorrente', 'prazoAcervoInt', 'prazoTotal','indexacao', 'legislacao','eliminar','permanente','acoes'];
  public dataSource;
  public clienteId;

  constructor(
    private temporalidadeService: TemporalidadeServiceService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private dadosService: DadosArquivisticosService,
    private _snackBar: MatSnackBar) {
      this.route.params.subscribe(params => this.nodeId = params['id']);
      this.clienteId = sessionStorage.getItem('clienteId');
      console.log(this.clienteId);
      if (this.clienteId === 'null') {
        this.clienteId = null;
      }
    }

  ngOnInit() {
    this.createForm();
    this.getTipo(this.nodeId);
    this.listarTemporalidade(this.nodeId);
  }

  async createForm() {
    this.temporalidadeForm = this.fb.group({
      id: [''],
      prazoAcervoCorrente: ['', Validators.required],
      prazoAcervoIntermediario: ['', Validators.required],
      prazoTotal: ['', Validators.required],
      isToEliminar: [false, Validators.required],
      isPermanente: [false, Validators.required],
      indexacao: [''],
      legislacao: [''],
      nodeDicionarioId: [this.nodeId, Validators.required]
    });

    await this.temporalidadeForm.get('prazoTotal').disable();
  }

  listarTemporalidade(nodeId : Number) {
    this.temporalidadeService.listTemporalidade(nodeId).subscribe(data => {
      if (data.length > 0) {
        this.isToSave = false;
      } else {
        this.isToSave = true;
      }
      this.loading = false;
      this.dataSource = new MatTableDataSource(data);
    }, err => {
      this.isToSave = true;
      console.error(err);
      this.loading = false;
      // this.openSnackBar('Nenhuma temporalidade cadastrada neste tipo documental !', true);
    });
  }

  async saveTemporalidade(temporalidade: TemporalidadeModel) {
    this.loading = true;
    await this.temporalidadeService.saveTemporalidade(temporalidade).subscribe(async () => {
      await this.openSnackBar('Temporalidade salva com sucesso !', false);
      await this.resetPostSave();
      await this.listarTemporalidade(this.nodeId);
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  resetPostSave() {
    this.isToSave = false;
    this.loading = false;
    this.temporalidadeForm.reset();
    this.eliminar = false;
    this.permanente = false;
    this.valorCorrente = 0;
    this.valorIntermediario = 0;
  }

  getObjectToEdit(temporalidade: TemporalidadeModel) {
    // Setando valores nas variáveis
    this.temporalidadeForm.get('prazoTotal').disable();
    this.isToEdit = true;
    this.isToSave = true;
    this.valorCorrente = temporalidade.prazoAcervoCorrente;
    this.valorIntermediario = temporalidade.prazoAcervoIntermediario;

    // Setando valor no formulário
    this.temporalidadeForm.patchValue({
      id: temporalidade.id,
      isPermanente: temporalidade.isPermanente,
      isToEliminar: temporalidade.isToEliminar,
      nodeDicionarioId: temporalidade.nodeDicionarioId,
      prazoAcervoCorrente: temporalidade.prazoAcervoCorrente,
      prazoAcervoIntermediario: temporalidade.prazoAcervoIntermediario,
      prazoTotal: temporalidade.prazoTotal,
      indexacao: temporalidade.indexacao,
      legislacao: temporalidade.legislacao
    });

    // Testando os tipos de guarda e atualizando os booleanos
    if (temporalidade.isPermanente) {
      this.eliminar = false;
      this.permanente = true;
    }
    if (temporalidade.isToEliminar) {
      this.permanente = false;
      this.eliminar = true;
    }
  }

  editTemporalidade(temporalidade: TemporalidadeModel) {
    this.temporalidadeService.editTemporalidade(temporalidade).subscribe(data => {
      console.log(data);
      this.openSnackBar('Temporalidade editada com sucesso !', false);
      this.resetPostSave();
      this.listarTemporalidade(this.nodeId);
    }, err => {
      console.error(err);
    });
  }

  confirmDelete(id) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar esta temporalidade ?', from: 'temporalidade.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.deleteTemporalidade(id);
      }
    });
  }

  deleteTemporalidade(id: Number) {
    this.temporalidadeService.deleteTemporalidade(id).subscribe(() => {
      console.log('Ok');
      this.openSnackBar('Temporalidade excluída com sucesso !', false);
      this.listarTemporalidade(this.nodeId);
      this.isToSave = true;
      this.isToEdit = false;
      this.temporalidadeForm.get('prazoTotal').disable();
    }, err => {
      console.error(err);
    });
  }

  getTipo(nodeId: Number) {
    this.dadosService.listarNodeDicionario(nodeId).subscribe(data => {
        this.tipoName = data.title;
        this.loading = false;
      }, err => {
        console.error(err);
      });
  }

  async setPrazoTotal(valor, local) {
    if (local === 'CORRENTE') {
      this.valorCorrente = valor;
    } else if (local === 'INTERMEDIARIO') {
      this.valorIntermediario = valor;
    }

    if ((this.valorCorrente !== null && this.valorCorrente !== '') && (this.valorIntermediario !== null && this.valorIntermediario !== '')) {
      const total = Number(this.valorCorrente) + Number(this.valorIntermediario);
      this.temporalidadeForm.get('prazoTotal').setValue(total);
    }
  }

  changeEliminar(e) {
    if (e.checked) {
      this.permanente = false;
      this.eliminar = true;

      // set value in form
      this.temporalidadeForm.get('isToEliminar').setValue(true);
      this.temporalidadeForm.get('isPermanente').setValue(false);
    }
  }

  changePermanente(e) {
    if (e.checked) {
      this.eliminar = false;
      this.permanente = true;
    }

    // set value in form
    this.temporalidadeForm.get('isPermanente').setValue(true);
    this.temporalidadeForm.get('isToEliminar').setValue(false);
  }

  saveOrEdit() {
    if (this.isToSave && !this.isToEdit) {
      this.temporalidadeForm.get('nodeDicionarioId').setValue(Number(this.nodeId));
      if (this.temporalidadeForm.valid && (this.permanente !== false || this.eliminar !== false)) {
        this.temporalidadeForm.get('prazoTotal').enable();
        this.saveTemporalidade(this.temporalidadeForm.value);
      } else {
        this.openSnackBar('Preencha todos os campos obrigatórios !', true);
      }
    } else if (this.isToSave && this.isToEdit){
      this.temporalidadeForm.get('nodeDicionarioId').setValue(Number(this.nodeId));
      if (this.temporalidadeForm.valid && (this.permanente !== false || this.eliminar !== false)) {
        this.temporalidadeForm.get('prazoTotal').enable();
        this.editTemporalidade(this.temporalidadeForm.value);
      } else {
        this.openSnackBar('Preencha todos os campos obrigatórios !', true);
      }
    }
  }

  openHelpDialog(message: string, link?: string) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + "px";
    } else {
      largura = innerWidth - innerWidth / 2 + "px";
    }

    const dialogRef = this.dialog.open(GlobalHelpDialogComponent, {
      data: { message, link },
      width: largura,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
    });
  }

  // SnackBar
  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/temporalidade/temporalidade.component.ts